import { render } from "./UserPromocodes.vue?vue&type=template&id=518053de&scoped=true"
import script from "./UserPromocodes.vue?vue&type=script&lang=js"
export * from "./UserPromocodes.vue?vue&type=script&lang=js"

import "./UserPromocodes.vue?vue&type=style&index=0&id=518053de&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518053de"]])

export default __exports__